import { Breadcrumbs, HorizontalLinkGroup } from 'components/navigation';
import { useUserHasAccess } from 'hooks/useUserHasAccess';
import PropTypes from 'prop-types';
import React, { Fragment, useMemo } from 'react';

export function Layout(props) {

    const userHasAccess = useUserHasAccess();

    const routes = useMemo(() => {
        return [
            { location: props.defaultPath, title: "Document Types", permission: "Documents:Manage" },
            { location: "/document-settings/documents", title: "All Documents" }
        ]
            .filter(r => !r.permission || userHasAccess(r.permission))
    }, [props.defaultPath, userHasAccess]);

    return (
        <Fragment>
            <div className="row">

                <Breadcrumbs items={props.breadcrumbs} />

                <h1>Document Management</h1>
            </div>

            <div className="row">
                <div className="spacer-bottom-medium">
                    <HorizontalLinkGroup links={routes} exactRouteMatch={true}></HorizontalLinkGroup>
                </div>
            </div>

            <div className='row'>
                {props.children}
            </div>
        </Fragment>
    );
}

Layout.propTypes = {
    breadcrumbs: PropTypes.array,
    defaultPath: PropTypes.string.isRequired,
    children: PropTypes.node
};
